export default $ => {

  // Check if select2 exists
  if (typeof $('body').select2 !== 'function') {
    return;
  }

  // remove data attributes then re-add them
  $('#membership_sportingClub').select2({placeholder: '', width: '100%', allowClear: true});
  const $select = $('#membership_federation');

  function pushDataAttribute(name, val) {
    $select.attr('data-'+name, val);
  }

  function popDataAttribute(name) {
    const val = $select.attr('data-'+name);
    $select.removeData(name);
    $select.removeAttr('data-'+name);
    return val;
  }

  const ajax = popDataAttribute('ajax');
  const ajaxUrl = popDataAttribute('ajax-url');
  const ajaxParam = popDataAttribute('ajax-param');
  $select.select2({placeholder: '', width: '100%', allowClear: true});
  pushDataAttribute('ajax-param', ajaxParam);
  pushDataAttribute('ajax-url', ajaxUrl);
  pushDataAttribute('ajax', ajax);
}



// WEBPACK FOOTER //
// ./assets/js/scripts/membership-form.js